/**
 * Tienda Aby se migro a otra base de datos: su cartera ya no se cobra desde
 * AmericanFly. Sus clientes NO deben aparecer en ningun reporte de saldos
 * (estados de cuenta ni antiguedades), aunque si siguen apareciendo en la
 * operacion de tienda (ventas, abonos, cortes) y en el historico de ventas.
 *
 * Uso:
 *   import { sinTiendaAby } from "../../carteraFiltros";
 *   let allClientes = sinTiendaAby(response.data);
 */
const AREAS_ABY = process.env.REACT_APP_AREAS_ABY;

/** Devuelve el _id del area, venga poblada como objeto o como ObjectId plano. */
function idArea(area) {
  if (!area) return "";
  return String(typeof area === "object" ? area._id || "" : area);
}

/** true si el cliente pertenece al area Tienda Aby. */
export function esTiendaAby(cliente) {
  const areas = cliente?.areas;
  if (!areas) return false;
  const lista = Array.isArray(areas) ? areas : [areas];
  return lista.some((a) => idArea(a) === String(AREAS_ABY));
}

/** Quita de una lista de clientes a los de Tienda Aby. */
export function sinTiendaAby(clientes) {
  if (!Array.isArray(clientes)) return clientes;
  return clientes.filter((c) => !esTiendaAby(c));
}

/**
 * Quita registros (surtidos, notas de cargo, ventas...) cuyo cliente sea de
 * Tienda Aby. Espera que el cliente venga poblado en `clientes[0]`.
 */
export function sinDocsTiendaAby(docs) {
  if (!Array.isArray(docs)) return docs;
  return docs.filter((d) => !esTiendaAby(d?.clientes?.[0] || d?.clientes));
}

export default sinTiendaAby;
